import React from "react";
import $ from "jquery";
import LogoSvg from "../assets/LogoSvg";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

export default function PopupRegistModal() {
  const { t } = useTranslation();
  const handleButtonClick = () => {
    $("#popupRegistModalClose").click();

    setTimeout(function () {
      $("body").addClass("modal-open");
    }, 400);
  };

  return (
    <div
      className="modal fade"
      id="popupRegistModal"
      tabIndex="-1"
      aria-labelledby="popupRegistModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header py-2" style={{ borderBottom: "none" }}>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="popupRegistModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="text-lg-center">
                <div id="logo" className="m-0">
                  <LogoSvg height="60px" />
                </div>
                <div className="logo  mt-2">
                  <h5 className="m-0 mb-1 text-secondary font-weight-bold">
                    {t("commonNav.registrationModal.title")}
                  </h5>
                </div>
              </div>
              <div
                className="row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="m-2">
                  <a
                    className="btn_1"
                    data-toggle="modal"
                    data-target="#personalRegistModal"
                    href="#"
                    onClick={() => {
                      handleButtonClick();
                    }}
                    style={{
                      width: 120,
                      height: 110,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <i
                        className="fas fa-user mb-2"
                        style={{ fontSize: "x-large" }}
                      />
                      <p style={{ fontSize: "medium" }}>
                        {t("commonNav.registrationModal.individualUser")}
                      </p>
                    </div>
                  </a>
                </div>
                <div className="m-2">
                  <a
                    className="btn_2"
                    data-toggle="modal"
                    data-target="#registModal"
                    href="#"
                    onClick={() => {
                      handleButtonClick();
                    }}
                    style={{
                      width: 120,
                      height: 110,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <i
                        className="fas fa-building mb-2"
                        style={{ fontSize: "x-large" }}
                      />
                      <p style={{ fontSize: "medium" }}>
                        {t("commonNav.registrationModal.corpUser")}
                      </p>
                    </div>
                  </a>
                </div>
                <h6 className="m-0 my-1 text-secondary font-weight-bold">
                  ※ {t("commonNav.registrationModal.warningNotice")}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
